import { Collapse, Drawer, Tag, Tooltip } from "antd"
import { DrawerCustom } from "../../../../../../Components/CustomUi/Drawer"
import { ContainerGavetaMostrar } from "./styled"
import { ItensPerfilTypes } from "../../../../../../services/perfil"
import { Render } from "../../../../../../Components/CustomUi/render"
import { agruparPermissoesPorModulo, corDoModulo } from "../meta"
import { Box } from "../../../../../../Components/CustomUi/box"
import { LineDivider } from "../../../../../../Components/CustomUi/LineDivider"
import Carregando from "../../../../../../Components/CustomUi/loading"

interface GavetaMostrarProps {
    equipe_cliente: any[]
    membro_selecionado: any
    perfis: any[]
    modulos: any[]
    modulos_sistema: any[]
    tabSelecionado: string
    loading_clientes: boolean
    loading_consultoria: boolean
    aberto: boolean
    onClose: Function
}

export const GavetaMostrar: React.FC<GavetaMostrarProps> = ({ equipe_cliente, membro_selecionado, perfis, modulos, modulos_sistema, tabSelecionado, loading_clientes, loading_consultoria, aberto, onClose }) => {
    const { Panel } = Collapse

    const tooltipPermissao = (permissao: any) => (
        <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
            <div>Acesso: {permissao?.acesso === 1 ? '✅' : '❌'}</div>
            <div>Inclusão: {permissao?.inclusao === 1 ? '✅' : '❌'}</div>
            <div>Alteração: {permissao?.alteracao === 1 ? '✅' : '❌'}</div>
            <div>Exclusão: {permissao?.exclusao === 1 ? '✅' : '❌'}</div>
        </div>
    )

    // Para Consultoria: agrupa as permissões do membro selecionado por módulo
    const modulosDoMembro = (() => {
        if (tabSelecionado !== 'Consultoria' || !membro_selecionado?.perfil?.permissoes || !modulos_sistema) return [];

        const permissoes = membro_selecionado.perfil.permissoes;
        const modulosMap = new Map();

        permissoes.forEach((permissao: any) => {
            const modulo = modulos_sistema.find((m: any) => m?.cod === permissao?.cod_modulo_rotina);
            if (modulo?.nome) {
                if (!modulosMap.has(modulo.nome)) {
                    modulosMap.set(modulo.nome, { nome: modulo.nome, cod: modulo.cod, permissoes: [] });
                }
                modulosMap.get(modulo.nome).permissoes.push(permissao);
            }
        });

        return Array.from(modulosMap.values());
    })();

    return (
        <DrawerCustom open={aberto} onClose={onClose} title={tabSelecionado === 'Clientes' ? 'Equipe e acessos' : 'Módulos e permissões'} width={500}>
            <ContainerGavetaMostrar>
                <Render condition={tabSelecionado === 'Clientes'}>
                    <Render condition={loading_clientes}>
                        <Carregando animation legenda="Carregando equipe..." height="500px" justifyContent="center" size="small" />
                    </Render>
                    <Render condition={!loading_clientes && equipe_cliente?.length > 0}>
                        <Collapse accordion expandIconPosition="end">
                            {equipe_cliente?.map((item) => {
                                const perfilTratado = perfis?.find(
                                    (perfil) => perfil.cod === item?.cod_perfil_cliente
                                );
                                return (
                                    <Panel
                                        key={item?.cod}
                                        header={
                                            <div className="header__accordion">
                                                <div className="icone__modulo">
                                                    {(item?.usuario_nome || 'US').substring(0, 2).toUpperCase()}
                                                </div>
                                                <div className="header__title">
                                                    <h3>{item?.usuario_nome}</h3>
                                                    <span>{perfilTratado?.nome}</span>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="tags__container">
                                            <Render condition={perfilTratado?.permissoes && perfilTratado?.permissoes?.length > 0}>
                                                {agruparPermissoesPorModulo(perfilTratado?.permissoes, modulos)?.map((modulo: any, index: number) => (
                                                    <div className="modulo__grupo" key={index}>
                                                        <h4>{modulo?.modulo_nome}</h4>
                                                        <Render condition={modulo.permissoes && modulo.permissoes?.length > 0}>

                                                            {modulo.permissoes?.map((permissao: any, idx: number) => (
                                                                <Tooltip key={idx} title={tooltipPermissao(permissao)} placement="top">
                                                                    <Tag color={corDoModulo(modulo?.modulo_nome)} style={{ padding: '3px 10px', fontWeight: 'bold', width: 'fit-content', cursor: 'pointer' }}>
                                                                        {permissao.rotina_nome}
                                                                    </Tag>
                                                                </Tooltip>
                                                            ))}

                                                            <LineDivider marginTop={10} />

                                                        </Render>
                                                    </div>
                                                ))}
                                            </Render>
                                            <Render condition={!perfilTratado?.permissoes || perfilTratado?.permissoes?.length === 0}>
                                                <span style={{ color: '#999' }}>Sem permissões ativas.</span>
                                            </Render>
                                        </div>
                                    </Panel>
                                );
                            })}
                        </Collapse>
                    </Render>
                    <Render condition={equipe_cliente?.length === 0 && !loading_clientes}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '500px' }}>
                            <span style={{ color: '#999' }}>Nenhuma equipe encontrada.</span>
                        </div>
                    </Render>
                </Render>
                <Render condition={tabSelecionado === 'Consultoria'}>
                    <Render condition={loading_consultoria}>
                        <Carregando animation legenda="Carregando módulos e permissões..." height="500px" justifyContent="center" size="small" />
                    </Render>
                    <Render condition={!loading_consultoria && modulosDoMembro?.length > 0}>
                        <Collapse accordion expandIconPosition="end">
                            {modulosDoMembro.map((modulo: any, index: number) => (
                                <Panel
                                    key={modulo.cod || index}
                                    header={
                                        <div className="header__accordion">

                                            <div className="header__title">
                                                <h3>{modulo?.nome}</h3>
                                                <span>{modulo.permissoes?.length} permiss{modulo.permissoes?.length === 1 ? 'ão' : 'ões'}</span>
                                            </div>
                                        </div>
                                    }
                                >

                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                        {modulo.permissoes?.map((permissao: any, idx: number) => (
                                            <Tooltip key={idx} title={tooltipPermissao(permissao)} placement="top">
                                                <Tag color={corDoModulo(modulo?.nome)} style={{ padding: '3px 10px', fontWeight: 'bold', width: 'fit-content', marginTop: '5px', cursor: 'pointer' }}>
                                                    {permissao?.rotina_nome || permissao?.nome}
                                                </Tag>
                                            </Tooltip>
                                        ))}
                                    </div>

                                </Panel>
                            ))}
                        </Collapse>
                    </Render>
                    <Render condition={modulosDoMembro.length === 0 && !loading_consultoria}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '500px' }}>
                            <span style={{ color: '#999' }}>Sem permissões ativas para este membro.</span>
                        </div>
                    </Render>
                </Render>
            </ContainerGavetaMostrar>
        </DrawerCustom>
    )
}